export default "__VITE_ASSET__fd870847__"